module.exports = __webpack_public_path__ + "static/media/jar.4bda95fe.png";